<template>
    <div>
        <footer>
        <p class="credits">                       
            <br><br><img  @click="render_home" v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo" :width="skin.header_desktop.logo_width" alt="" style="max-width: 270px; max-height: 240px;"><br><br></p>                                             
        </footer>
    </div>
</template>

<script>
export default {
    name: "footerOdin",
    props: ['skin', 'translation', 'language'],
    data() {
        return {
            password: "",
            password2: "",
            show1: true,
            show2: true,
            status: {
                message: "",
                type: ""
            },
            login_inProcess: false
        }
    },
    computed: {

    },
    methods:{
        render_home() {
             if (this.actualRoute=='Home') {
                const iframeContainer = document.querySelector('.holds-the-iframe');
                if (iframeContainer) {
                    // Enviar mensaje al iframe para que se recargue
                    const iframe = iframeContainer.querySelector('iframe');
                    if (iframe) {
                        iframe.contentWindow.postMessage({ action: 'reloadIframe' }, '*');
                        this.$store.dispatch("setHomeButton", false);
                        this.$store.dispatch("setMisdatos", false);
                        this.menuOpen = false;
                    } else {
                            // console.error('No se encontró un iframe dentro del contenedor con la clase "holds-the-iframe".');
                    }
                } else {
                    // console.error('No se encontró el contenedor con la clase "holds-the-iframe".');
                    this.$store.dispatch("setMisdatos", false);
                    this.$store.dispatch("setHomeButton", false);
                    this.menuOpen = false;
                }                
            } else {
                router.push({name:"Home"}).catch(() => {})
                this.$store.dispatch("setHomeButton", false);
                this.$store.dispatch("setMisdatos", false);
                this.menuOpen = false;
            }
        },
    }
}

</script>

<style scoped>
footer {
    position: relative;
    width: 100%;
    height: auto;
    background: #26292E;
    text-align: center;
    z-index: 99;
}
</style>